import { _ as t } from "../internals/export.js";
import { o } from "../internals/object-set-prototype-of.js";
t({
  target: "Object",
  stat: !0
}, {
  setPrototypeOf: o
});